import React from 'react';
import './index.css';

const TextAlignCenter = ({ header, text, marginTopClass = '' }) => {
    return (
        <div className={`blog-text-align-center-container ${marginTopClass}`} dangerouslySetInnerHTML={{__html: header + text}}></div>
    )
}

export default TextAlignCenter;